import React from 'react'
import { Helmet } from "react-helmet";
import EventsPage from '../../components/Events/EventsPage'

const Events = () => {
  return (
    <div>
        <Helmet>
  {/* Google Analytics Tag */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Basic Meta */}
  <title>Events | Aptech Lekki Centre - Tech Events, Graduations, and Career Fairs</title>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta
    name="description"
    content="Stay updated with Aptech Lekki Centre's latest events — tech career fairs, coding workshops, graduation ceremonies, Middlesex University scholarships, and more. Discover how our students achieve global success through vibrant community activities."
  />
  
  <meta
    name="keywords"
    content="Aptech Lekki Events, Tech events Lekki, Career fairs Lagos, Aptech graduation events, Middlesex scholarship Aptech, Coding workshops Lekki, Student events Lagos, Career Quest Nigeria, Tech community events Lekki, IT training events Lekki"
  />

  <meta name="author" content="Aptech Lekki Centre" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://aptechlekki.com/events" />

  {/* Open Graph Meta for Social Media */}
  <meta property="og:title" content="Events | Aptech Lekki Centre" />
  <meta property="og:description" content="Explore Aptech Lekki Centre’s tech events, career fairs, graduation ceremonies, and scholarship opportunities. Connect, learn, and grow with us." />
  <meta property="og:url" content="https://aptechlekki.com/events" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://aptechlekki.com/assets/og_image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Events | Aptech Lekki Centre" />
  <meta name="twitter:description" content="Join Aptech Lekki Centre’s tech events and career activities. Find opportunities, connect with the community, and celebrate success!" />
  <meta name="twitter:image" content="https://aptechlekki.com/assets/og_image.jpg" />
</Helmet>

        <EventsPage />
    </div>
  )
}

export default Events